export const Maintenance = () => (
  <div className="d-flex justify-content-center align-items-center vh-100">
    <div className="text-center" style={{ maxWidth: '32rem' }}>
      <p>
        <img
          src="//www.breakfreeholidays.co.uk/blog/wp-content/uploads/2020/11/breakfree-logo.png"
          alt="Breakfree Holidays"
          height="50"
        />
      </p>
      <p className="h2">We are currently making exciting changes to further improve your site experience!</p>
      <p>Don&apos;t worry, we will be back shortly.</p>
      <p>Thank you for your patience!</p>
      <p className="h4">Contact Us</p>
      <p>
        <a href="tel:03448484534">0344 84 84 534</a>
      </p>
      <p>
        <a href="mailto:enquiries@breakfreeholidays.co.uk">enquiries@breakfreeholidays.co.uk</a>
      </p>
    </div>
  </div>
)
